import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { CompartmentSelectorManagementContent } from './Components/CompartmentSelectorManagementContent';

export const CompartmentSelectorManagement = (): React.JSX.Element => (
  <Page title="Compartment Selectors" accessKey="compartmentSelectors" isSearchable={true}>
    <CompartmentSelectorManagementContent />
  </Page>
);
